/*
 * Dropdown to Radio Buttons
 *
 * Any page or component which potentially have
 * different size of product, this method aligns height of image.
 **/

custom.dropdownToRadio = (() => {
  // Config variables
  const targetClass = 'js-dropdown-to-radio';
  const initializedClass = 'js-dropdown-to-radio--initialized';

  function radioButtonEventHandler(id = '', selector = null) {
    const $radioButtons = $(`[data-dropdown-id="${id}"]`).find(
      "input[type='radio']",
    );

    $radioButtons.each((index, radio) => {
      if ($(radio).val() === $(selector).find(':selected').val()) {
        $(radio).prop('checked', true);
      }
    });

    $radioButtons.on('change', (e) => {
      const selectedVal = $(e.currentTarget).attr('value');
      var sortOption = $(selector).find('option[value=' + selectedVal + ']');
      var event; // The custom event that will be created
      sortOption.one('input', function () {
        if (document.createEvent) {
          event = document.createEvent('Event');
          event.initEvent('change', true, true);
        } else {
          event = document.createEventObject();
          event.eventType = 'change';
        }
        event.eventName = 'change';
        if (document.createEvent) {
          selector.dispatchEvent(event);
        } else {
          selector.fireEvent('on' + event.eventType, event);
        }
      });
      sortOption.prop('selected', true).trigger('input');
    });
  }

  function handler(selector = null) {
    if ($(selector).hasClass(initializedClass)) return;

    const radioClass = $(selector).hasClass('sort-by-selector-collection')
      ? 'sort-by-radio-collection'
      : 'sort-by-radio';
    let output = '';
    const selectorId = $(selector).hasClass('ais-SortBy-select')
      ? $(selector).closest("[id*='sort-by-selector']").attr('id')
      : $(selector).data('selectorId');
    const currentValue = $(selector).val();
    $(selector)
      .find('option')
      .each((index, option) => {
        const optionValue = $(option).attr('value');
        const optionlabel = $(option).text();
        const sortByName = selectorId.replace('mobile-sort-by-selector', '');

        output += `
        <div class="custom-radio-wrapper w-1/2 md-up:w-auto">
          <div class="custom-radio">
            <input type="radio" name="sortBy${sortByName}" value="${optionValue}" class="input-radio">
            <span class="custom-radio__button"></span>
          </div>
          <label class="type-utility-medium-regular inline-block ml-6 align-middle" for="sortBy">${optionlabel}</label>
        </div>
      `;
        if (optionValue == currentValue)
          $(`input:radio[value="${optionValue}"]`).checked = true;
      });

    $(selector)
      .hide()
      .after(
        `<div data-dropdown-id="${selectorId}" class="flex flex-col gap-y-6 md-up:block">${output}</div>`,
      )
      .addClass(initializedClass);

    radioButtonEventHandler(selectorId, selector);
  }

  function init() {
    if (!$(`.${targetClass}`)) return;
    $(`.${targetClass}`).each((index, dropdown) => {
      handler(dropdown);
    });
  }

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/dropdown-to-radio.js